import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import LocaleContext from '../../contexts/LocaleContext';
import MainTitle from '../common/MainTitle';
import AppButton from '../common/AppButton';
import StudentGirlJpg from '../../assets/images/admissions/support-and-inquiries-media.jpg';
import StudentGirlWebp from '../../assets/images/admissions/support-and-inquiries-media.webp';
import useNavigationWithQuery from '../../hooks/useNavigationWithQuery';
import ImageLink from '../../js/utils/ImageLink';

export default function SupportAndInquiries({ image }) {
  const { t } = useTranslation(['AdmissionsPage']);
  const { locale } = useContext(LocaleContext);
  const { queryParams } = useNavigationWithQuery();

  return (
    <section className="support-and-inquiries">
      <MainTitle type="dark" className="text--2xl container hidden--desktop">
        <span>{t('needSupport')}</span>
        <span className="decorated-line decorated-line--dark decorated-line--left">
          {t('haveQuestion')}
        </span>
      </MainTitle>

      <div className="support-and-inquiries__container container">
        <div className="support-and-inquiries__content">
          <MainTitle type="dark" className="text--2xl container hidden--mobile">
            <span className="decorated-line decorated-line--dark decorated-line--right">
              {t('needSupport')}
            </span>
            <span>{t('haveQuestion')}</span>
          </MainTitle>

          <div className="support-and-inquiries__description">
            <p className="description">{t('supportDescription')}</p>

            <AppButton tag="a" linkPath={`/${locale}/contact#contact-form${queryParams}`}>
              {t('contactUs')}
            </AppButton>
          </div>
        </div>
        {image && (
          <div className="support-and-inquiries__media">
            <picture>
              <source srcSet={ImageLink(image?.url)} type="image/webp" />
              <img src={ImageLink(image?.url)} alt={image?.alt} />
            </picture>
          </div>
        )}
      </div>
    </section>
  );
}
